var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__clip0_323_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.266 12.276c0-.815-.066-1.635-.207-2.438h-11.32v4.621h6.483a5.555 5.555 0 0 1-2.4 3.647v2.998h3.868c2.27-2.09 3.576-5.177 3.576-8.828Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.74 24c3.236 0 5.966-1.062 7.954-2.896l-3.867-2.998c-1.075.731-2.464 1.146-4.083 1.146-3.13 0-5.785-2.112-6.737-4.952h-3.99v3.091a12.002 12.002 0 0 0 10.723 6.61Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.002 14.3a7.188 7.188 0 0 1 0-4.594V6.615H2.016a12.01 12.01 0 0 0 0 10.776l3.986-3.09Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.74 4.75a6.52 6.52 0 0 1 4.603 1.799l3.426-3.426A11.533 11.533 0 0 0 12.74 0 11.998 11.998 0 0 0 2.016 6.615l3.987 3.09C6.95 6.863 9.609 4.75 12.74 4.75Z",
    fill: "#EA4335"
  }))));
};
export default SvgGoogle;